// ── SAKURA PETALS ──────────────────────────────────────
(function() {
  const canvas = document.getElementById('sakura-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  const PETAL_COUNT = 38;
  const petals = [];

  function randomPetal(spread) {
    return {
      x: Math.random() * canvas.width,
      y: spread ? Math.random() * canvas.height : -20 - Math.random() * 200,
      size: 4 + Math.random() * 7,
      opacity: 0.2 + Math.random() * 0.55,
      speedY: 0.5 + Math.random() * 1.2,
      speedX: -0.4 + Math.random() * 0.8,
      rot: Math.random() * Math.PI * 2,
      rotSpeed: -0.02 + Math.random() * 0.04,
      sway: Math.random() * Math.PI * 2,
      swaySpeed: 0.01 + Math.random() * 0.015,
      pink: Math.random() > 0.35,
    };
  }

  for (let i = 0; i < PETAL_COUNT; i++) {
    petals.push(randomPetal(true));
  }

  function drawPetal(p) {
    ctx.save();
    ctx.translate(p.x, p.y);
    ctx.rotate(p.rot);
    ctx.globalAlpha = p.opacity;
    const s = p.size;
    const r = Math.floor(255);
    const g = p.pink ? Math.floor(140 + Math.random()*60) : 230;
    const b = p.pink ? Math.floor(175 + Math.random()*40) : 235;
    const col = `rgb(${r},${g},${b})`;
    for (let i = 0; i < 5; i++) {
      ctx.save();
      ctx.rotate((Math.PI * 2 / 5) * i);
      ctx.beginPath();
      ctx.ellipse(0, -s * 0.55, s * 0.32, s * 0.55, 0, 0, Math.PI * 2);
      ctx.fillStyle = col;
      ctx.fill();
      ctx.restore();
    }
    ctx.beginPath();
    ctx.arc(0, 0, s * 0.18, 0, Math.PI * 2);
    ctx.fillStyle = p.pink ? 'rgba(255,100,140,0.6)' : 'rgba(255,200,210,0.5)';
    ctx.fill();
    ctx.restore();
  }

  function animate() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (const p of petals) {
      p.sway += p.swaySpeed;
      p.x += p.speedX + Math.sin(p.sway) * 0.5;
      p.y += p.speedY;
      p.rot += p.rotSpeed;
      if (p.y > canvas.height + 20) {
        Object.assign(p, randomPetal(false));
      }
      drawPetal(p);
    }
    requestAnimationFrame(animate);
  }
  animate();
})();

// ── PRODUCT IMAGE SWAP ON HOVER ──────────────────────
document.querySelectorAll('[data-back-img]').forEach(function(card) {
  const img = card.querySelector('.pc-img img');
  if (!img) return;
  const front = img.src;
  const back = card.getAttribute('data-back-img');
  card.addEventListener('mouseenter', function() { img.src = back; });
  card.addEventListener('mouseleave', function() { img.src = front; });
});

// ── PRODUCT PAGE THUMB SWAP ───────────────────────────
document.querySelectorAll('.product-thumb').forEach(function(thumb) {
  thumb.addEventListener('click', function() {
    const mainImg = document.querySelector('.product-main-img');
    if (mainImg) mainImg.src = this.src;
    document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
    this.classList.add('active');
  });
});

// ── AJAX ADD TO CART ─────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: data })
        .then(r => r.json())
        .then(function() {
          fetch('/cart.js')
            .then(r => r.json())
            .then(function(cart) {
              const cartEl = document.querySelector('.cart-count');
              if (cartEl) cartEl.textContent = '[' + cart.item_count + ']';
              const btn = form.querySelector('[name="add"]');
              if (btn) {
                const orig = btn.textContent;
                btn.textContent = 'Added!';
                setTimeout(function() { btn.textContent = orig; }, 1200);
              }
            });
        })
        .catch(function(err) { console.error('Cart error:', err); });
    });
  });
});
